import React from "react";
import { Link } from "react-router-dom";
import "./coming.scss";
import Logo from "../../Assets/Images/logo.png";
import Plane from "../../Assets/Images/plane.png";

const Coming = () => {
  return (
    <div className="login-main">
      <div className="login-form coming-width">
        <div className="row">
          <div className="col-md-6">
            <div className="coming-left">
              <div className="company-logo">
                <img src={Logo} />
              </div>
              <h1>Coming Soon!</h1>
              <p>In-Transit is in development and will be available soon.</p>
              <Link to='/'>   <button type="submit" className="yellow-btn">
                Back to Home
              </button></Link>
            </div>
          </div>

          <div className="col-md-6">
            <div className="coming-plane">
              <img src={Plane} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Coming;
